import React, { useMemo } from 'react';
export interface NodeInfoPanelProps {
  labelName: string;
  info: any;
  treeNodeType?: string;
}

const NodeInfo = (props: NodeInfoPanelProps) => {
  const { labelName, info, treeNodeType } = props;

  const renderListNodeInfo = (detail) => {
    if (treeNodeType === 'ProteinFormulation') {
      return detail.map((info, index) => (
        <div id={`nodeinfo-protein-${index}`} className={'nodeInfo'} key={index}>
          {info.protienType}
          {<b>:</b>} {info.ingredientName},{info.concMgml} mg/mL, {info.concMm} mM
        </div>
      ));
    } else if (treeNodeType === 'Seed') {
      return detail.map((info, index) => (
        <div id={`nodeinfo-seed-${index}`} key={index} className={'nodeInfo'}>
          {info.type}
          {<b>:</b>} {info.name},{info.concentration} {info.concentrationUnit}
        </div>
      ));
    }
  };

  const returnData = (label, isArray) => {
    return (
      <div id={`nodeinfo-row-${label.replace(/\s+/g, '-').toLowerCase()}`} className="row" style={{ paddingInline: '2%' }}>
        <div id={`nodeinfo-label-${label.replace(/\s+/g, '-').toLowerCase()}`} className="nodeInfo nodeLabel col-4">{label}</div>
        <div
          id={`nodeinfo-value-${label.replace(/\s+/g, '-').toLowerCase()}`}
          style={{ wordWrap: 'break-word' }}
          className={isArray ? 'nodeInfo col-8' : 'nodeInfo col-6'}
        >
          {isArray ? renderListNodeInfo(info) : info}
        </div>
      </div>
    );
  };

  const createNodesInfo = useMemo(() => {
    const data = [];
    if (Array.isArray(info)) {
      data.push(returnData(labelName, true));
    } else {
      data.push(returnData(labelName, false));
    }
    return data;
  }, [labelName, info]);

  return <div id={`nodeinfo-wrapper-${labelName.replace(/\s+/g, '-').toLowerCase()}`} style={{ paddingTop: '10px' }}>{createNodesInfo}</div>;
};
export default NodeInfo;
